import type { PublicationValidator } from '@/components/user_catalog/OrderedPublicationCardsField';
import { hasPlayableAudio } from '@/components/user_catalog/publications/publicationFacts';
import { HeroAudioRequiredTag } from './HeroAudioRequiredTag';

/** A deleted publication is exempt: the row already says it is gone. */
export const heroAudioValidator: PublicationValidator = (publication) =>
  publication && !hasPlayableAudio(publication) ? (
    <HeroAudioRequiredTag />
  ) : null;
